// extracted by mini-css-extract-plugin
export default {"basketButton":"components-Basket-basketButton-themes-BGH-styles__basketButton--bKLnh"};